import { useLotSizingTableColumn } from '@/features/lot-sizing/hooks/use-lot-sizing-table-column';
import { useDataTable } from '@/hooks/use-data-table';

export function useLotSizingTable() {
  const columns = useLotSizingTableColumn();

  const dataTable = useDataTable({
    data: [],
    columns,
    pageCount: 0,
    renderFallbackValue: '-',
    enableSorting: false,
    getRowId: (row) => `${row.id}`,
  });

  return {
    ...dataTable,
  };
}
